import React from 'react'
import Image from "next/image";
import Link from "next/link";
import Head from "next/head";
import styles from "../sch-test/delhi-prefit.module.css";
import csatWebBanner from "../../assets/images/slider/TNPSC-GRII-IIA-mock test- Webbanner.jpg";
import csatMobBanner from "../../assets/images/slider/mob-banner/TNPSC-GRII-IIA-Prelims-state - Mob-banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { useState,useEffect } from 'react';
import Form from "./mocktest-form";
import {useRouter} from 'next/router';

const allIndiaPrelimsMockTestSeries = () => {

    const prelimlist =[
        {list:" Date of Mock Test Results Publication: 8th Sep 2024 at 6:00 PM"},
        {list:" Mode of Mock Test: Only Offline mode"},
        {list:" Extra Time will be given for the visually challenged candidates and they need to bring a scribe"},
        
            
        
      ]

    const feestructure = [
        { date: "GS Paper I", cont: "26.05.2024", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "26.05.2024", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure2 = [
        { date: "GS Paper I", cont: "02.06.2024", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "02.06.2024", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure3 = [
        { date: "GS Paper I", cont1: "09.06.2024", cont2: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont1: "09.06.2024", cont2: "02:30 pm to 04:30 pm"}
      ]

    
     
  return (
        <>

            <Head>
             
                <meta charset="UTF-8" />
                <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title> TNPSC Group II & IIA Prelims Mock Test | Shankar IAS Academy</title>
                <meta name="title" content="TNPSC Group II & IIA Prelims Mock Test | Shankar IAS Academy" />
                <meta name="description" content="TNPSC Group II & IIA Prelims Mock Test for effective exam preparation. Strengthen your performance with expert-designed tests and detailed solutions." />
				<meta name="keywords" content="TNPSC Group II & IIA Prelims Mock Test 2024, TNPSC Group II & IIA Prelims Mock Test, TNPSC Group II Prelims Mock Test, TNPSC Group IIA Prelims Mock Test, Group II & IIA Prelims Mock Test, SIA All India Prelims Mock Test 2024, SIA All India Prelims Mock Test" />
                <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-mock-test/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="TNPSC Group II & IIA Prelims Mock Test | Shankar IAS Academy" />
                <meta property="og:description" content="TNPSC Group II & IIA Prelims Mock Test for effective exam preparation. Strengthen your performance with expert-designed tests and detailed solutions." />
                <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-mock-test/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="sch-test"/>

            <div className="container">
                <div className='row'>
                    <div className='col'>
                       <h1 className={`${styles.pagemaintitle}`}>TNPSC Group II-IIA Prelims Test SIA Tentative Key 2024</h1>
                    </div>
                </div>
               <div className='row pt-4 d-none d-md-block'>
                    <div className='col'>
                        <Image src={csatWebBanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                    </div>
                </div>
                <div className='row pt-4 d-block d-md-none'>
                    <div className='col'>
                        <Image src={csatMobBanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                    </div>
                </div> 
            </div>

            

          {/* <Form />  */}

     <div className="container-fluid pt-3">
     <section className="pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
    {/* <h2 className={`${styles.aboutheading1}`}>TNPSC Gr II State level Mock Test - 2024 Results </h2>
        <div className="row pb-3">
                    <Link href="https://www.shankariasacademy.com/pdf/tnpsc-group-ii-mock-test-2024/GT-with-GS-Results.pdf" target="_blank" className={`${styles.paybill1}`}> Click Here TNPSC Gr II State level Mock Test GT+GS Results</Link><br/>
                    <Link href="https://www.shankariasacademy.com/pdf/tnpsc-group-ii-mock-test-2024/GE-with-GS-Results.pdf" target="_blank" className={`${styles.paybill1}`}> Click Here TNPSC Gr II State level Mock Test GE+GS Results</Link><br/>
                    <Link href="https://www.shankariasacademy.com/pdf/tnpsc-group-ii-mock-test-2024/OVERALL-GE-GT-Results.pdf" target="_blank" className={`${styles.paybill1}`}> Click Here TNPSC Gr II State level Mock Test OVERALL GE+GT Results</Link><br/>
         </div>*/}
         
     <h2 className={`${styles.aboutheading1}`}>  TNPSC Group II-IIA Prelims Test SIA Tentative Key 2024 </h2>
                 
                
                <div className="row">
                 <Link href="https://www.shankariasacademy.com/pdf/tnpsc-group-ii-mock-test-2024/TNPSC-Group-II-IIA-GS-SIA-Tentative-Key.pdf" target="_blank" className={`${styles.paybill1}`}> Click Here TNPSC Group II-IIA Prelims Test GS SIA Tentative Key</Link><br/>
                 <Link href="https://www.shankariasacademy.com/pdf/tnpsc-group-ii-mock-test-2024/TNPSC-Group-II-IIA-GT-SIA-Tentative-Key.pdf" target="_blank" className={`${styles.paybill1}`}> Click Here TNPSC Group II-IIA Prelims Test GT SIA Tentative Key</Link>
                </div>
                </section>

         
     </div>

        

    

 {/*<div className="container-fluid pt-4">
     
    <section className="pt-md-3 pt-lg-4" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
      <div className="container"> 
       <div className="row">
       <h2 className={`${styles.Feature}  mb-0`} > Mock Test Details </h2>
        <div className="col-12 col-xl-4 pt-2 ">
           <div className={`${styles.facultyborder1}  h-100`}>
               <div className="row pt-3 pb-3">
                  <div className="col-6 col-xl-6 offset-xl-2">
                      <span >Date of Mock Test:</span><br />
                      <span className={`${styles.dayValue}`}>06<sup>th</sup></span><br />
                      <span>Sep 2024</span>
                  </div>
                  <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                    <Image src="/images/icon/Calender-01.png" alt="clendar" width={50} height={50} />
                  </div>
              </div>
         </div>
     </div>

        <div className="col-12 col-xl-4 pt-2">
        <div className={`${styles.facultyborder1} h-100`}>
            <div className="row pt-3 pb-3">
            
           
            <div className="col-6 col-xl-6 offset-xl-2">
                
                <span>Timings:</span><br />
                <span className={`${styles.dayValue}`}>09:30 am </span><br />
                <span>12:30 pm</span>
               
            </div>
            <div className="col-6 col-xl-4 pt-3 pt-xl-0">
            <Image src="/images/icon/clock-01.png" alt="clendar" width={50} height={50} />
            </div>
            </div>
          </div> 
        </div>

        <div className="col-12 col-xl-4 pt-2 ">
           <div className={`${styles.facultyborder1}  h-100`}>
               <div className="row pt-3 pb-3">
                  <div className="col-6 col-xl-6 offset-xl-2">
                      <span >Closing Date:</span><br />
                      <span className={`${styles.dayValue}`}>03<sup>rd</sup></span><br />
                      <span>Sep 2024</span>
                  </div>
                  <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                    <Image src="/images/icon/Calender-01.png" alt="clendar" width={50} height={50} />
                  </div>
              </div>
         </div>
     </div>
      

      </div>
    <div className="container">
        <div className="row">
           <div className="col-12 col-xl-6 pt-3">
              
                <ul className={`${styles.ulclass} ps-1 pt-2`}>
                     {prelimlist.map((item,index)=>(
                    <li
                           className={`${styles.ulliclass} ${styles.acheiverrank}`}
                           id={styles.acheiverrankspecial} key={index}
                          >
                        <div className="d-inline">
                            <p className={`${styles.ullispan} d-inline`}>
                             {item.list}
                            </p>
                        </div>
                    </li>
                    ))}
                </ul>
          </div>
       
             
        </div>
    </div>

       
    </div> 

</section>

{/*<div className="container-fluid" style={{background: '#F4F6F8'}}>
        <div className="container">
      
        </div>
 
             <div className='text-center mt-2 mb-2 text-danger h3'>Registration Closed</div>
                <div className="py-2">
                <div className="row">
                    <h2 className={`${styles.sectiontitle} pt-3`}>Schedule Details</h2>
                    <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
                    <div className={`${styles.facultyborder4} p-3`}>
                        <p className={`${styles.sectionsubtitle} mb-2 mx-3`}>Mock Test 1</p>
                    </div>

                    <div className="pt-3">
                        <div className="row mx-auto">
                        <div className="col ps-0">
                        <div className="table-responsive text-nowrap">
                            <table className="table">
                            <tbody>
                                {feestructure.map((item, index) => (
                                <tr key={index}>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                        </div>
                        </div>
                    </div>



                    </div>

                    <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
                    <div className={`${styles.facultyborder4} p-3`}>
                        <p className={`${styles.sectionsubtitle} mb-2 mx-3`}>Mock Test 2</p>
                    </div>

                    <div className="pt-3">
                        <div className="row mx-auto">
                        <div className="col ps-0">
                        <div className="table-responsive text-nowrap">
                            <table className="table">
                            <tbody>
                                {feestructure2.map((item, index) => (
                                <tr key={index}>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                        </div>
                        </div>
                    </div>

                    </div>

                    <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
                    <div className={`${styles.facultyborder4}`}>
                        <div className="p-3">
                        <p className={`${styles.sectionsubtitle} mb-2 mx-3`}>Mock Test 3</p>
                        </div>
                    </div>

                    <div className="pt-3">
                        <div className="row mx-auto">
                        <div className="col ps-0 ps-xl-0 p-xl-0">
                            <div className="table-responsive text-nowrap">
                            <table className="table">
                                <tbody>
                                {feestructure3.map((item, index) => (
                                    <tr key={index}>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
                                    </tr>
                                ))}
                                <tr>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </div>

                    </div>
                </div>

                </div>
            </div>
        </div>  */}


      {/*<section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
        <div className="container"> 
      
            <div className={`${styles.head}  pt-2 pb-2`}>
        <h3> Mock Test - Venue</h3>
      </div>
     
        <div className="row">
          <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>CHENNAI - ANNA NAGAR</span>
                      <p >Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040. <br/>76677 66266</p>
                  </div>

                  
              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox}  `}>
               <div className="row pt-3 pb-3">
                  <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>CHENNAI - ADYAR </span>
                      <p >No-2/23, 3rd Cross Street, Padmanabhanagar, Adyar, Chennai-600 020. <br/>90252 78278</p>
                  </div>

              </div>
         </div>
     </div>



     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Madurai</span>
                     <p>340 MIG Colony, GSP Plaza, Bata show room, 5th floor, Anna Nagar, Sathamangalam, <br/>Madurai-625020.<br/> 97896 22555</p>
                      
                  </div>

              </div>
         </div>
     </div> 


     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Salem</span>
                     <p>No.207/5 United Arcade, Kauveri Avenue, State Bank Colony, Junction Main Road,  <br/>Salem-636 004.<br/> 89400 80039</p>
                      
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Trichy</span>
                     <p>N.R.Towers, A9 (N), Salai Road, Thillai Nagar, <br/>Trichy-620 018. <br/>Landmark: LIC -Rock Fort Branch Building<br/>97896 64555</p>
                      
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Coimbatore</span>
                     <p>No.790, 2nd Floor, Cross Cut Road, Gandhipuram (Next to Josco Jewellers),  <br/>Coimbatore-641 009.<br/>99945 51898</p>
                      
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                        <span>Namakkal</span>
                        <p>Block No -2/67, 1st Floor ( West ) , <br/>Thillaipuram Main Road, Namakkal-637 001.  <br/>99944 34921<br/>04286-223007</p>
                   </div>
              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                        <span>Thiruvarur</span>
                        <p>No 91, ONS Complex, Nethaji Road, <br/>Thiruvarur-610 001.<br/>04366 222972<br/>97877 34943</p>
                  </div>
              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                        <span>Harur</span>
                        <p>Kongu Multipurpose Coaching Center Kongu Mini Mahal Campus
Mopiripatti(Post) , Harur(Taluk) , Dharmapuri(Dist) . Pincode : 636903<br/>Contact person Mr. Ashok 8508206666</p>
                  </div>
              </div>
         </div>
     </div>

     

    </div>
        </div> 
        <br/>


            
      </section> */}


            
            <Footer />
        </>
    )
}

export default allIndiaPrelimsMockTestSeries;